import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { useCreateComparatorOptions } from './useCreateComparatorOptions';
import { ComparatorSelectType } from '../types';
import { AnyComparator, RegexComparator } from '../../../../types';
import { SelectOption } from '../../../../contexts';
import { useIsCatalogESIndex } from '../../../../hooks/useIsCatalogESIndex';

const REGEX_FEATURE_FLAG = 'UseRegexInSearchQuery';

export const useRegexComparatorOptions = (): SelectOption<AnyComparator>[] => {
  const isRegexFFEnabled = useFeatureFlag(REGEX_FEATURE_FLAG);
  const isCatalogESIndex = useIsCatalogESIndex();
  const createComparatorOptions = useCreateComparatorOptions();
  const regexComparatorOptions = createComparatorOptions(
    RegexComparator,
    ComparatorSelectType.regex,
  );

  return isRegexFFEnabled && !isCatalogESIndex ? regexComparatorOptions : [];
};
